/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

type Size = 'smallest' | 'small' | 'large' | 'larger' | 'largest';

type Alignment = 'right' | 'left' | 'center';

function width(size) {
  return {
    smallest: 468,
    small: 960,
    large: 1200,
    larger: 1360,
    largest: 1920,
  }[size];
}

class Container extends Component<{
  size: Size | number,
  padded: boolean,
  children?: any,
  style?: Object,
  className?: string,
  align: Alignment,
}> {
  static defaultProps = {
    size: 'small',
    padded: false,
    align: 'left',
  };

  render() {
    const { align, padded, size, children, style, className } = this.props;
    let maxWidth = size;
    if (typeof size === 'string') {
      maxWidth = width(size);
    }

    return (
      <div
        style={{ textAlign: align, maxWidth: padded ? maxWidth + 24 * 2 : maxWidth, ...style }}
        className={names(Styles.Container, padded && Styles.Padded, className)}>
        {children}
      </div>
    );
  }
}

const Styles = {
  Container: css`
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  `,
  Padded: css`
    padding-left: 32px;
    padding-right: 32px;
  `,
};

export default Container;



// WEBPACK FOOTER //
// ./src/ui/components/core/Container.js